'use strict';
(function () {
  var MAX_SETS = 12; // safety cap, in case something prevents overflow from ever being reached

  document.querySelectorAll('.mdpb').forEach(function (root) {
    var tabs = root.querySelectorAll('.mdpb-tab');
    var tracks = root.querySelectorAll('.mdpb-track');
    var prevBtn = root.querySelector('.mdpb-nav--prev');
    var nextBtn = root.querySelector('.mdpb-nav--next');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var duplicate = root.getAttribute('data-duplicate') !== 'false';
    var speed = parseFloat(root.getAttribute('data-speed')) || 40; // pixels per second
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var paused = false;
    var lastTime = null;
    var resumeTimer = null;
    // One entry per track: the width of a single logo "set" (used both to
    // decide whether more clones are needed and, later, as the loop-reset
    // distance — every clone is identical, so this stays valid however many
    // copies end up on the page).
    var unitWidths = new WeakMap();

    // A handful of logos (e.g. only 3 partners in a tab) can be narrower
    // than the viewport even doubled up, which leaves nothing to scroll —
    // the marquee then just sits still. Clone the original set repeatedly
    // until there is comfortably more than two viewports' worth of content,
    // so the loop always has room to run continuously.
    function ensureEnoughContent(track) {
      var inner = track.querySelector('.mdpb-track__inner');
      var firstSet = inner && inner.querySelector('.mdpb-track__set');
      if (!inner || !firstSet) return;
      var unit = firstSet.getBoundingClientRect().width;
      if (!unit) return;
      unitWidths.set(track, unit);
      if (!duplicate) return;
      var sets = inner.querySelectorAll('.mdpb-track__set').length;
      var target = Math.max(track.clientWidth * 2, unit * 2);
      while (inner.scrollWidth < target && sets < MAX_SETS) {
        inner.appendChild(firstSet.cloneNode(true));
        sets++;
      }
    }

    function activeTrack() {
      return root.querySelector('.mdpb-track.is-active');
    }

    function tick(ts) {
      requestAnimationFrame(tick);
      // Without duplication there's only one copy of the content, so wrapping
      // scrollLeft back to 0 would show a blank gap right before the reset —
      // continuous autoplay only makes sense once the loop content exists.
      if (paused || !autoplay || !duplicate || reduceMotion) { lastTime = ts; return; }
      if (lastTime == null) { lastTime = ts; return; }
      var dt = (ts - lastTime) / 1000;
      lastTime = ts;
      var track = activeTrack();
      if (!track) return;
      var unit = unitWidths.get(track);
      if (!unit) return;
      track.scrollLeft += speed * dt;
      if (track.scrollLeft >= unit) track.scrollLeft -= unit;
    }

    tracks.forEach(ensureEnoughContent);
    // Logo images loading in can widen the set after the initial measurement.
    root.querySelectorAll('.mdpb-logo img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { tracks.forEach(ensureEnoughContent); }, { once: true });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        tracks.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-tab') === key); });
        // A track hidden at load time (display:none) measures as zero-width,
        // so it may still be missing its clones/unit width the first time
        // it's actually shown — (re)compute now that it has real layout.
        ensureEnoughContent(activeTrack());
        lastTime = null;
      });
    });

    function nudge(dir) {
      var track = activeTrack();
      if (!track) return;
      paused = true;
      var item = track.querySelector('.mdpb-logo');
      var step = item ? item.offsetWidth + 36 : 246;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; lastTime = null; }, 900);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; lastTime = null; });

    requestAnimationFrame(tick);
  });
})();
